/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createIndustryMaster = /* GraphQL */ `mutation CreateIndustryMaster(
    $input: CreateIndustryMasterInput!
    $condition: ModelIndustryMasterConditionInput
  ) {
    createIndustryMaster(input: $input, condition: $condition) {
      id
      startDateTime
      endDateTime
      mainCategory
      subCategory
      item
      itemFlg
      scaleCode
      industryName
      searchName
      stringSearchName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.CreateIndustryMasterMutationVariables,
  APITypes.CreateIndustryMasterMutation
>;
export const updateIndustryMaster = /* GraphQL */ `mutation UpdateIndustryMaster(
    $input: UpdateIndustryMasterInput!
    $condition: ModelIndustryMasterConditionInput
  ) {
    updateIndustryMaster(input: $input, condition: $condition) {
      id
      startDateTime
      endDateTime
      mainCategory
      subCategory
      item
      itemFlg
      scaleCode
      industryName
      searchName
      stringSearchName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateIndustryMasterMutationVariables,
  APITypes.UpdateIndustryMasterMutation
>;
export const deleteIndustryMaster = /* GraphQL */ `mutation DeleteIndustryMaster(
    $input: DeleteIndustryMasterInput!
    $condition: ModelIndustryMasterConditionInput
  ) {
    deleteIndustryMaster(input: $input, condition: $condition) {
      id
      startDateTime
      endDateTime
      mainCategory
      subCategory
      item
      itemFlg
      scaleCode
      industryName
      searchName
      stringSearchName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.DeleteIndustryMasterMutationVariables,
  APITypes.DeleteIndustryMasterMutation
>;
export const createFinancialAnalysisMaster = /* GraphQL */ `mutation CreateFinancialAnalysisMaster(
    $input: CreateFinancialAnalysisMasterInput!
    $condition: ModelFinancialAnalysisMasterConditionInput
  ) {
    createFinancialAnalysisMaster(input: $input, condition: $condition) {
      id
      classification
      mainCategory
      subCategory
      item
      scaleCode
      surplus
      industryCode
      yearEdition
      NoTC
      ANoE
      DR
      ER
      CR
      QR
      FAtER
      FAtLTCR
      IBDR
      ARtAPR
      CIPEtARR
      CATR
      CATD
      ARTR
      ARTD
      CDTR
      CDTD
      ITR
      ITD
      STR
      STD
      WIPTR
      WIPTD
      CIPTR
      CIPTD
      RMSTR
      RMSTD
      FATR
      FATD
      TFATR
      TFATD
      OITR
      OITD
      TATR
      TATD
      LTR
      LTD
      APTR
      APTD
      IBDTR
      IBDTD
      CIPRTR
      CIPRTD
      STBTR
      STBTD
      ETR
      ETD
      GPM
      OPM
      RPM
      PTPM
      NPM
      ORtTAR
      PTPtTAR
      NPtTAR
      RoE
      OPtOAR
      CoSR
      SGAEtSR
      IBtNSR
      IRoIBD
      SGR
      OPGR
      TAGR
      EGR
      MSpE
      MOEpE
      MGVApE
      MOPpE
      LER
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.CreateFinancialAnalysisMasterMutationVariables,
  APITypes.CreateFinancialAnalysisMasterMutation
>;
export const updateFinancialAnalysisMaster = /* GraphQL */ `mutation UpdateFinancialAnalysisMaster(
    $input: UpdateFinancialAnalysisMasterInput!
    $condition: ModelFinancialAnalysisMasterConditionInput
  ) {
    updateFinancialAnalysisMaster(input: $input, condition: $condition) {
      id
      classification
      mainCategory
      subCategory
      item
      scaleCode
      surplus
      industryCode
      yearEdition
      NoTC
      ANoE
      DR
      ER
      CR
      QR
      FAtER
      FAtLTCR
      IBDR
      ARtAPR
      CIPEtARR
      CATR
      CATD
      ARTR
      ARTD
      CDTR
      CDTD
      ITR
      ITD
      STR
      STD
      WIPTR
      WIPTD
      CIPTR
      CIPTD
      RMSTR
      RMSTD
      FATR
      FATD
      TFATR
      TFATD
      OITR
      OITD
      TATR
      TATD
      LTR
      LTD
      APTR
      APTD
      IBDTR
      IBDTD
      CIPRTR
      CIPRTD
      STBTR
      STBTD
      ETR
      ETD
      GPM
      OPM
      RPM
      PTPM
      NPM
      ORtTAR
      PTPtTAR
      NPtTAR
      RoE
      OPtOAR
      CoSR
      SGAEtSR
      IBtNSR
      IRoIBD
      SGR
      OPGR
      TAGR
      EGR
      MSpE
      MOEpE
      MGVApE
      MOPpE
      LER
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateFinancialAnalysisMasterMutationVariables,
  APITypes.UpdateFinancialAnalysisMasterMutation
>;
export const deleteFinancialAnalysisMaster = /* GraphQL */ `mutation DeleteFinancialAnalysisMaster(
    $input: DeleteFinancialAnalysisMasterInput!
    $condition: ModelFinancialAnalysisMasterConditionInput
  ) {
    deleteFinancialAnalysisMaster(input: $input, condition: $condition) {
      id
      classification
      mainCategory
      subCategory
      item
      scaleCode
      surplus
      industryCode
      yearEdition
      NoTC
      ANoE
      DR
      ER
      CR
      QR
      FAtER
      FAtLTCR
      IBDR
      ARtAPR
      CIPEtARR
      CATR
      CATD
      ARTR
      ARTD
      CDTR
      CDTD
      ITR
      ITD
      STR
      STD
      WIPTR
      WIPTD
      CIPTR
      CIPTD
      RMSTR
      RMSTD
      FATR
      FATD
      TFATR
      TFATD
      OITR
      OITD
      TATR
      TATD
      LTR
      LTD
      APTR
      APTD
      IBDTR
      IBDTD
      CIPRTR
      CIPRTD
      STBTR
      STBTD
      ETR
      ETD
      GPM
      OPM
      RPM
      PTPM
      NPM
      ORtTAR
      PTPtTAR
      NPtTAR
      RoE
      OPtOAR
      CoSR
      SGAEtSR
      IBtNSR
      IRoIBD
      SGR
      OPGR
      TAGR
      EGR
      MSpE
      MOEpE
      MGVApE
      MOPpE
      LER
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.DeleteFinancialAnalysisMasterMutationVariables,
  APITypes.DeleteFinancialAnalysisMasterMutation
>;
export const createPublicManagementIndicators = /* GraphQL */ `mutation CreatePublicManagementIndicators(
    $input: CreatePublicManagementIndicatorsInput!
    $condition: ModelPublicManagementIndicatorsConditionInput
  ) {
    createPublicManagementIndicators(input: $input, condition: $condition) {
      id
      usingStartDate
      usingEndDate
      yearEdition
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.CreatePublicManagementIndicatorsMutationVariables,
  APITypes.CreatePublicManagementIndicatorsMutation
>;
export const updatePublicManagementIndicators = /* GraphQL */ `mutation UpdatePublicManagementIndicators(
    $input: UpdatePublicManagementIndicatorsInput!
    $condition: ModelPublicManagementIndicatorsConditionInput
  ) {
    updatePublicManagementIndicators(input: $input, condition: $condition) {
      id
      usingStartDate
      usingEndDate
      yearEdition
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdatePublicManagementIndicatorsMutationVariables,
  APITypes.UpdatePublicManagementIndicatorsMutation
>;
export const deletePublicManagementIndicators = /* GraphQL */ `mutation DeletePublicManagementIndicators(
    $input: DeletePublicManagementIndicatorsInput!
    $condition: ModelPublicManagementIndicatorsConditionInput
  ) {
    deletePublicManagementIndicators(input: $input, condition: $condition) {
      id
      usingStartDate
      usingEndDate
      yearEdition
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.DeletePublicManagementIndicatorsMutationVariables,
  APITypes.DeletePublicManagementIndicatorsMutation
>;
export const createInputDataSave = /* GraphQL */ `mutation CreateInputDataSave(
    $input: CreateInputDataSaveInput!
    $condition: ModelInputDataSaveConditionInput
  ) {
    createInputDataSave(input: $input, condition: $condition) {
      id
      mailAddress
      userId
      conditionsName
      financialAnalysisData
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.CreateInputDataSaveMutationVariables,
  APITypes.CreateInputDataSaveMutation
>;
export const updateInputDataSave = /* GraphQL */ `mutation UpdateInputDataSave(
    $input: UpdateInputDataSaveInput!
    $condition: ModelInputDataSaveConditionInput
  ) {
    updateInputDataSave(input: $input, condition: $condition) {
      id
      mailAddress
      userId
      conditionsName
      financialAnalysisData
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateInputDataSaveMutationVariables,
  APITypes.UpdateInputDataSaveMutation
>;
export const deleteInputDataSave = /* GraphQL */ `mutation DeleteInputDataSave(
    $input: DeleteInputDataSaveInput!
    $condition: ModelInputDataSaveConditionInput
  ) {
    deleteInputDataSave(input: $input, condition: $condition) {
      id
      mailAddress
      userId
      conditionsName
      financialAnalysisData
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.DeleteInputDataSaveMutationVariables,
  APITypes.DeleteInputDataSaveMutation
>;
export const createContractInfo = /* GraphQL */ `mutation CreateContractInfo(
    $input: CreateContractInfoInput!
    $condition: ModelContractInfoConditionInput
  ) {
    createContractInfo(input: $input, condition: $condition) {
      id
      systemId
      detailsManagementNo
      mailAddress
      userId
      identityId
      custCode
      custName
      managerCode
      orderDate
      usingStartDate
      usingEndDate
      yearEdition
      mailFrom
      mailNotice
      mailNoticeCc
      productCode
      productName
      usingStartMailFlg
      usingEndMailFlg
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.CreateContractInfoMutationVariables,
  APITypes.CreateContractInfoMutation
>;
export const updateContractInfo = /* GraphQL */ `mutation UpdateContractInfo(
    $input: UpdateContractInfoInput!
    $condition: ModelContractInfoConditionInput
  ) {
    updateContractInfo(input: $input, condition: $condition) {
      id
      systemId
      detailsManagementNo
      mailAddress
      userId
      identityId
      custCode
      custName
      managerCode
      orderDate
      usingStartDate
      usingEndDate
      yearEdition
      mailFrom
      mailNotice
      mailNoticeCc
      productCode
      productName
      usingStartMailFlg
      usingEndMailFlg
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateContractInfoMutationVariables,
  APITypes.UpdateContractInfoMutation
>;
export const deleteContractInfo = /* GraphQL */ `mutation DeleteContractInfo(
    $input: DeleteContractInfoInput!
    $condition: ModelContractInfoConditionInput
  ) {
    deleteContractInfo(input: $input, condition: $condition) {
      id
      systemId
      detailsManagementNo
      mailAddress
      userId
      identityId
      custCode
      custName
      managerCode
      orderDate
      usingStartDate
      usingEndDate
      yearEdition
      mailFrom
      mailNotice
      mailNoticeCc
      productCode
      productName
      usingStartMailFlg
      usingEndMailFlg
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.DeleteContractInfoMutationVariables,
  APITypes.DeleteContractInfoMutation
>;
export const createLoginInfo = /* GraphQL */ `mutation CreateLoginInfo(
    $input: CreateLoginInfoInput!
    $condition: ModelLoginInfoConditionInput
  ) {
    createLoginInfo(input: $input, condition: $condition) {
      id
      userId
      sessionId
      expireDateTime
      expireDateTimeUnix
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.CreateLoginInfoMutationVariables,
  APITypes.CreateLoginInfoMutation
>;
export const updateLoginInfo = /* GraphQL */ `mutation UpdateLoginInfo(
    $input: UpdateLoginInfoInput!
    $condition: ModelLoginInfoConditionInput
  ) {
    updateLoginInfo(input: $input, condition: $condition) {
      id
      userId
      sessionId
      expireDateTime
      expireDateTimeUnix
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateLoginInfoMutationVariables,
  APITypes.UpdateLoginInfoMutation
>;
export const deleteLoginInfo = /* GraphQL */ `mutation DeleteLoginInfo(
    $input: DeleteLoginInfoInput!
    $condition: ModelLoginInfoConditionInput
  ) {
    deleteLoginInfo(input: $input, condition: $condition) {
      id
      userId
      sessionId
      expireDateTime
      expireDateTimeUnix
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.DeleteLoginInfoMutationVariables,
  APITypes.DeleteLoginInfoMutation
>;
